import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";

import Index from "./pages/Index";
const Seminovos = lazy(() => import("./pages/Seminovos"));
const Carrinho = lazy(() => import("./pages/Carrinho"));
const Seguro = lazy(() => import("./pages/Seguro"));
const Pagamento = lazy(() => import("./pages/Pagamento"));
const Contato = lazy(() => import("./pages/Contato"));
const Orcamento = lazy(() => import("./pages/Orcamento"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const Admin = lazy(() => import("./pages/Admin"));
const Auth = lazy(() => import("./pages/Auth"));
const PagamentoSucesso = lazy(() => import("./pages/PagamentoSucesso"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
  </div>
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/seminovos" element={<Seminovos />} />
            <Route path="/carrinho" element={<Carrinho />} />
            <Route path="/seguro" element={<Seguro />} />
            <Route path="/pagamento" element={<Pagamento />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/orcamento" element={<Orcamento />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/adm-login" element={<AdminLogin />} />
            <Route path="/admin-login" element={<Navigate to="/adm-login" replace />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/:tab" element={<Admin />} />
            <Route path="/pagamento-sucesso" element={<PagamentoSucesso />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
